import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { SCUIButton, SCUIAutoCompleteInput } from '../../../../atomic/atoms';

import ScheduleGroupCommand from '../../../../services/command/scheduleGroupCommand/ScheduleGroupCommand.services';
import { OperatorQuery } from '../../../../services/query';
import { GUED } from './groupUserEditDialog.classes';

export const GroupUserEditDialog = ({ open, getUsers, onClose, setIsLoading, scheduleGroupId }: any) => {
    const [username, setUsername] = useState<string>('');
    const [operators, setOperators] = useState<any[]>();

    const { t } = useTranslation();

    const handleClose = () => {
        setUsername('');
        onClose();
    };

    useEffect(() => {
        const getOperatorList = async () => {
            try {
                let operators: any = await OperatorQuery.GetOperatorService();
                if (operators) {
                    setOperators(operators);
                }
            } catch {
                Swal.fire(t('general.anErrorOccured', '', 'error'));
            }
        };
        getOperatorList();
    }, []);

    const handleAddUser = () => {
        if (username) {
            setIsLoading(true);
            if (scheduleGroupId) {
                ScheduleGroupCommand.CreateGroupUser({
                    scheduleGroupId,
                    username,
                })
                    .then((res: any) => {
                        if (res) {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: t('general.success'),
                                showConfirmButton: false,
                                timer: 1500,
                            });
                            setIsLoading(false);
                            getUsers();
                            handleClose();
                        }
                    })
                    .catch(() => {
                        Swal.fire(t('general.anErrorOccured'), '', 'error');
                        setIsLoading(false);
                    });
            }
        } else {
            Swal.fire(t('scheduleGroup.groupUser.missingUsername'), '', 'error');
        }
    };

    return (
        <Dialog className={GUED.dialog} open={open} onClose={handleClose}>
            <DialogTitle className={GUED.title}>{t('scheduleGroup.groupUser.addUser')}</DialogTitle>
            <DialogContent className={GUED.content} sx={{ width: '400px', padding: '24px !important' }}>
                <div className={GUED.operatorAutocompleteWrap}>
                    <SCUIAutoCompleteInput
                        list={operators}
                        onChange={(_: any, newValue: any) => {
                            setUsername(newValue.username);
                        }}
                        multiple={false}
                        txtPlaceHolder={t('scheduleGroup.groupUser.enterUsername')}
                        searchValue="username"
                    />
                </div>
            </DialogContent>
            <DialogActions className={GUED.actions}>
                <SCUIButton
                    className={GUED.addButton}
                    style={{ marginRight: '8px' }}
                    size="s"
                    type="primary"
                    sizeType="default"
                    text={t('general.add')}
                    onClick={handleAddUser}
                />
                <SCUIButton
                    className={GUED.cancelButton}
                    type="primary"
                    sizeType="default"
                    size="s"
                    text={t('general.cancel')}
                    onClick={handleClose}
                />
            </DialogActions>
        </Dialog>
    );
};
